import { Cushion, Rectangle, Space, Typography } from '@pitchero/react-ui';
import PropTypes from 'prop-types';
import React from 'react';

const NewsArticleQuote = ({ author, body }) => (
  <Space bottom="medium">
    <Rectangle fill="#f8f8f8" radius="16px" border="1px solid #eee">
      <Cushion all="medium" component="div">
        <Typography color="black" size={20} weight="bold">
          {body}
        </Typography>
        {author && (
          <Space top="small" component="div">
            <Typography color="black">{`- ${author}`}</Typography>
          </Space>
        )}
      </Cushion>
    </Rectangle>
  </Space>
);

NewsArticleQuote.defaultProps = {
  author: null,
};

NewsArticleQuote.propTypes = {
  author: PropTypes.string,
  body: PropTypes.string.isRequired,
};

export default NewsArticleQuote;
